import { Users, UserCheck, StickyNote, Loader2 } from 'lucide-react'

export interface TeamQueueTakeoverBarProps {
  isClaiming: boolean
  onClaim: () => void
  onAddNote?: () => void
}

export function TeamQueueTakeoverBar({
  isClaiming,
  onClaim,
  onAddNote,
}: TeamQueueTakeoverBarProps) {
  return (
    <div className="border-t border-amber-200 bg-gradient-to-r from-amber-50 via-orange-50 to-amber-50 px-4 py-3.5 lg:px-6">
      <div className="flex flex-wrap items-center justify-between gap-3 lg:mx-auto lg:max-w-5xl">
        <div className="flex items-center gap-3 min-w-0">
          <div className="flex h-9 w-9 flex-shrink-0 items-center justify-center rounded-xl bg-amber-100 text-amber-700 shadow-2xs">
            <Users className="h-5 w-5" />
          </div>
          <div className="min-w-0">
            <div className="flex items-center gap-2">
              <p className="text-xs font-bold text-amber-950 sm:text-sm">
                Chat en cola del equipo
              </p>
              <span className="rounded-full bg-amber-200/80 px-2 py-0.5 text-[10px] font-semibold text-amber-900">
                Sin asignar
              </span>
            </div>
            <p className="text-[11px] sm:text-xs text-amber-900/80">
              Este caso está esperando atención. Toma el caso para responder al cliente directamente.
            </p>
          </div>
        </div>

        <div className="flex items-center gap-2 flex-shrink-0">
          {onAddNote && (
            <button
              type="button"
              onClick={onAddNote}
              className="inline-flex items-center gap-1.5 rounded-lg border border-amber-300 bg-white px-3 py-1.5 text-xs font-medium text-amber-900 shadow-2xs transition-colors hover:bg-amber-100/60 active:scale-[0.98]"
            >
              <StickyNote className="h-3.5 w-3.5 text-amber-700" />
              <span>Dejar nota</span>
            </button>
          )}

          <button
            type="button"
            onClick={onClaim}
            disabled={isClaiming}
            className="inline-flex items-center gap-1.5 rounded-lg bg-[#075f55] px-4 py-1.5 text-xs font-bold text-white shadow-xs shadow-[#075f55]/20 transition-all hover:bg-[#064e46] disabled:opacity-50 active:scale-[0.98]"
          >
            {isClaiming ? (
              <>
                <Loader2 className="h-3.5 w-3.5 animate-spin" />
                <span>Tomando caso...</span>
              </>
            ) : (
              <>
                <UserCheck className="h-3.5 w-3.5" />
                <span>Tomar caso</span>
              </>
            )}
          </button>
        </div>
      </div>
    </div>
  )
}
